import { GET_AWB_PART_STATUSES } from '../actions/actionTypes';

import {AwbPartStatuses} from '../../models/AwbPart';

import { AWB_PART_STATUSES_SCHEMA } from '../../utils/awbPartStatuses';

const initialState: AwbPartStatuses = AWB_PART_STATUSES_SCHEMA;

export const awbPartStatusesReducer = (state = initialState, action: any) => {

  switch (action.type) {

    case GET_AWB_PART_STATUSES:
      return {
        ...state,
        import: [...action.payload.import],
        export: [...action.payload.export]
      }

    default:
      return state;
  }

};